import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../../data/richText'

export default defineType({
  name: 'settingsConfiguratorAccessories',
  title: 'Accessories Configurator',
  type: 'document',
  fields: [
    defineField({
      name: 'enabled',
      title: 'Enable accessories configurators',
      type: 'boolean',
      initialValue: true,
      description: 'Turning this off will hide accessories configurators from users',
    }),
    defineField({
      name: 'fitsYourVehicleLabel',
      title: 'Fits your vehicle label',
      type: 'string',
      description: 'Available placeholders: {make} | {model} | {generation}',
    }),
    defineField({
      name: 'promotionInfo',
      title: 'Promotion Info Bar',
      type: 'object',
      fields: [
        defineField({
          name: 'enabled',
          title: 'Show Info Bar',
          type: 'boolean',
          description: 'Turning this off will hide the info bar from users',
          initialValue: true,
        }),
        defineField({
          name: 'titlePrefix',
          title: 'Prefix',
          type: 'string',
          description: 'Displayed in bold next to the title (e.g., "SAVE UP TO 25%")',
        }),
        defineField({
          name: 'title',
          title: 'Title',
          type: 'string',
          description: 'Content displayed inline (e.g., "On All Apex Wheel Accessories with the purchase of 4 wheels")',
        }),
        defineField({
          name: 'content',
          title: 'Content',
          type: 'array',
          of: richTextContent,
          description: 'Content displayed in the modal when user clicks the info button',
        }),
      ],
    }),
    defineField({
      name: 'freeShippingInfo',
      title: 'Free shipping Info',
      type: 'object',
      fields: [
        defineField({
          name: 'enabled',
          title: 'Show Free shipping Info',
          type: 'boolean',
          initialValue: true,
        }),
        defineField({
          name: 'title',
          title: 'Title',
          type: 'string',
          description: 'Content displayed inline',
        }),
        defineField({
          name: 'content',
          title: 'Content',
          type: 'array',
          of: richTextContent,
          description: 'Content displayed in the modal',
        }),
      ],
    }),
    defineField({
      name: 'importantOrderNotes',
      title: 'Important order notes configuration',
      description:
        'For items automatically added to cart with wheels (centering rings or required accessories), define banners notifying users those products were added for free',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'importantOrderNoteItem',
          fields: [
            defineField({
              name: 'attributeSetKey',
              title: 'Attribute set',
              description: 'Ie apex_centering_rings or apex_lug_bolts',
              type: 'string',
              validation: (Rule) => Rule.required(),
            }),
            defineField({
              name: 'heading',
              title: 'Heading',
              description:
                'Ie "We are including centering rings because...". Use placeholders with attributes that are always present on this type of product (that start with "apex_"). For apex_centering_rings, use {apex_ring_id} | {apex_ring_od}',
              type: 'string',
              validation: (Rule) => Rule.required(),
            }),
            defineField({
              name: 'explanation',
              title: 'Short explanation',
              description:
                'Shown in smaller text. Use placeholders with attributes that are always present on this type of product (that start with "apex_"). For apex_centering_rings, use {apex_ring_id} | {apex_ring_od}',
              type: 'string',
              validation: (Rule) => Rule.required(),
            }),
            defineField({
              name: 'whyDoINeed',
              title: 'Why do I need this modal',
              description:
                'Longer form explanation shown in modal when user clicks "why do I need this?". If left empty, the button will be hidden.',
              type: 'array',
              of: richTextContent,
            }),
          ],
          preview: {
            select: {
              heading: 'heading',
              attributeSetKey: 'attributeSetKey',
            },
            prepare({ attributeSetKey, heading }) {
              return {
                title: attributeSetKey,
                subtitle: heading,
              }
            },
          },
        },
      ],
    }),
  ],
})
